var M = require("./vendors/materialize");
var Global = require("./global");
var Loading = require("./loading");

var global = new Global();
var loading = new Loading();   
 
$(function () {   
    global.onMainThemeLoading();
    global.setSearchPlaceholder(searchPlaceholder);  
 
    M.Collapsible.init(document.querySelectorAll('.collapsible.expandable'), { accordion: false});  
    
    $('#isCollapse').change(function (e) {
        console.log($('ul.collapsible li'));           
        if($('#isCollapse').prop('checked')){
            $('ul.collapsible li').removeClass('active');
            $('.collapsible-body').attr('style', 'display: none');
            
        } else {
            $('ul.collapsible li').addClass('active');
            $('.collapsible-body').attr('style', 'display: block');
        }
    });

    requestAnimationFrame(() => {
      setTimeout(() => {   
            require.ensure([], function (require) {
                require("./vendors/jquery-social-share-bar");

                $('#share-bar').share({
                    theme: 'circle', // or 'square'
                    animate: true,
                    popupWidth: 640,
                    popupHeight: 528,
                    channels: ['facebook', 'twitter', 'email'],
                    itemTriggerClass: 'js-share'
                });

                $('#download-files .tabs').tabs();

                $(".unexist").each(function () {

                    var $this = $(this);            

                    $this.click(function (e) {
                        e.preventDefault();

                        selectedCardsGroupID = $this.attr("data-groupid");
                        selectedCardsCategoryID = $this.attr("data-id");

                        var translationModal = M.Modal.getInstance($("#translateCardsModal"));
                        translationModal.open();
                    }); 
                });
            });
        }, 0);  
    });      
    
    var InitLazyTranslationLoad = function (lazyTranslations) {
        if ('IntersectionObserver' in window) {
            var lazyTranslationObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        initTranslationFormLoading();
                        lazyTranslationObserver.unobserve(entry.target);
                    }
                });
            });

            lazyTranslations.forEach(function (lazyTranslation) {
                lazyTranslationObserver.observe(lazyTranslation);
            });
        }
    };

    InitLazyTranslationLoad([].slice.call(document.querySelectorAll('.unexist')));          
});

var isGroupTranslationFormLoadred = false;
async function initTranslationFormLoading() {
    if (isGroupTranslationFormLoadred) {
        return;
    }
        
    isGroupTranslationFormLoadred = true;
    try {    
        const Translation = await import('./translation');   
        Translation.initTranslationForm();
    } catch (error) {
        console.error('An error occurred while loading the module:', error);
    }    
} 